import { FlipWords } from '@/components/ui/flip-words';
import { HoverEffect } from '@/components/ui/card-hover-effect';
import { BackgroundBeams } from '@/components/ui/background-beams';

const FLIP_WORDS = ['Innovadores', 'Sostenibles', 'Únicos', 'Modernos'];

const SERVICES = [
  {
    title: 'Diseño de Oficinas',
    description:
      'Espacios corporativos que inspiran productividad y bienestar. Diseñamos ambientes que reflejan la identidad de tu empresa.',
    link: '/servicios/diseno-oficinas',
  },
  {
    title: 'Mobiliario Corporativo',
    description:
      'Muebles de alta calidad adaptados a tus necesidades. Ergonomía, funcionalidad y estética en cada pieza.',
    link: '/servicios/mobiliario',
  },
  {
    title: 'Restauración de Muebles',
    description:
      'Recuperamos el valor de tu mobiliario clásico. Técnicas artesanales para devolverle vida a piezas únicas.',
    link: '/servicios/restauracion',
  },
  {
    title: 'Consultoría de Espacios',
    description:
      'Asesoramiento profesional para optimizar tus espacios de trabajo. Maximiza el potencial de cada metro cuadrado.',
    link: '/servicios/consultoria',
  },
  {
    title: 'Proyectos Llave en Mano',
    description:
      'Soluciones integrales de principio a fin. Nos encargamos de todo para que solo disfrutes del resultado.',
    link: '/servicios/proyectos',
  },
  {
    title: 'Mantenimiento Preventivo',
    description:
      'Cuidado continuo de tus muebles e instalaciones. Preserva la inversión y prolonga la vida útil de tus activos.',
    link: '/servicios/mantenimiento',
  },
];

/**
 * Página de demostración de componentes v0 integrados con branding INBOCA
 * 
 * Muestra:
 * 1. FlipWords - Animación de palabras en hero
 * 2. HoverEffect - Grid de tarjetas con efecto hover
 * 3. BackgroundBeams - Fondo animado en sección CTA
 */
export function V0ComponentsDemo() {
  return (
    <div className="bg-white text-gray-800">
      {/* Sección 1: Hero con FlipWords */}
      <section className="h-screen flex items-center justify-center px-4 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            INBOCA crea espacios{' '}
            <FlipWords words={FLIP_WORDS} className="text-5xl md:text-7xl" />
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Transformamos ambientes corporativos con diseño innovador, mobiliario de calidad
            y compromiso con la sostenibilidad.
          </p>
        </div>
      </section>

      {/* Sección 2: Servicios con HoverEffect */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Nuestros Servicios
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Soluciones integrales para espacios corporativos que impulsan el éxito de tu empresa
            </p>
          </div>
          <HoverEffect items={SERVICES} />
        </div>
      </section>

      {/* Sección 3: CTA con BackgroundBeams */}
      <section className="relative h-[40rem] w-full rounded-md bg-neutral-950 flex flex-col items-center justify-center antialiased overflow-hidden">
        <BackgroundBeams />
        <div className="relative z-10 max-w-2xl mx-auto p-4 text-center">
          <h2 className="text-white text-3xl md:text-5xl font-bold mb-6">
            Únete a la Innovación
          </h2>
          <p className="text-neutral-300 text-lg mb-8 max-w-xl mx-auto">
            Suscríbete para recibir las últimas tendencias en diseño corporativo,
            casos de éxito y contenido exclusivo de INBOCA.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <input
              type="email"
              placeholder="tucorreo@empresa.com"
              className="px-6 py-3 rounded-lg border border-neutral-700 bg-neutral-900 text-white placeholder:text-neutral-500 focus:ring-2 focus:ring-inboca-teal focus:border-transparent outline-none w-full sm:w-80"
            />
            <button className="px-8 py-3 bg-inboca-teal text-white font-semibold rounded-lg hover:bg-inboca-teal/90 transition-colors w-full sm:w-auto">
              Suscribirme
            </button>
          </div>
        </div>
      </section>

      {/* Sección 4: Footer de Demo */}
      <section className="py-12 px-4 bg-gray-50 border-t border-gray-200">
        <div className="max-w-6xl mx-auto text-center">
          <p className="text-gray-600 mb-4">
            Esta página demuestra la integración de componentes v0 con el branding INBOCA
          </p>
          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-500">
            <div>✅ FlipWords con text-inboca-teal</div>
            <div>✅ HoverEffect en modo claro</div>
            <div>✅ BackgroundBeams para fondos oscuros</div>
            <div>✅ 4R Framework aplicado</div>
          </div>
        </div>
      </section>
    </div>
  );
}
